import axios from "axios";
import { Base_URL } from "../url";

export const fetchACHDData = async () => {
  try {
    const response = await axios.get(`${Base_URL}/PayrollHeaderItem/GetACHDdata`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching ACHD data!";
  }
};

export const downloadCSVFile = async (payload) => {
  try {
    const response = await axios.post(
      `${Base_URL}/PayrollHeaderItem/downloadcsv`,
      payload,
      {
        responseType: 'blob' 
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading CSV file!";
  }
};

export const updateUTRNumber = async (payload) => {
  try {
    const response = await axios.put(
      `${Base_URL}/PayrollHeaderItem/UpdateUTR`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error updating UTR number!";
  }
};
